export default {
    loadDefaultLanguage: function (){
        return {
            type: 'I18N_LOAD_DEFAULT_LANGUAGE'
        };
    },
    loadLanguage: function(locale) {
        return {
            type: 'I18N_LOAD_LANGUAGE',
            locale: locale
        }
    },
};
